<template>
  <div class="sdg-section-header" :style="{ 'background-color': backgroundColor }">
    <div class="sdg-section-title">
      {{ sectionTitle }}
    </div>
    <div class="sdg-goals-container">
      <div 
        v-for="goal in uniqueSdgGoals" 
        :key="goal.id"
        class="sdg-goal-icon"
      >
        <img 
          :src="goal.icon || `/icons/sdg-${goal.goalNumber}.svg`" 
          :alt="goal.title"
          :title="goal.title"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SdgSectionHeader',
  props: {
    sectionType: {
      type: String,
      required: true,
      validator: value => ['environmental', 'social', 'governance'].includes(value)
    },
    issues: {
      type: Array,
      default: () => []
    },
    allSdgGoals: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    backgroundColor() {
      const colors = {
        environmental: '#E4FFF2',
        social: '#E4FBFF',
        governance: '#FFF4E8'
      };
      return colors[this.sectionType];
    },
    sectionTitle() {
      const titles = {
        environmental: 'Environmental',
        social: 'Social',
        governance: 'Governance'
      };
      return titles[this.sectionType];
    },
    uniqueSdgGoals() {
      // Collect all SDG goal IDs from all issues in this section
      const sdgGoalIds = new Set();
      
      this.issues.forEach(issue => {
        if (issue.sdgGoals && Array.isArray(issue.sdgGoals)) {
          issue.sdgGoals.forEach(goalId => {
            sdgGoalIds.add(goalId);
          });
        }
      });

      // Map the IDs to the full goal objects and sort by goal number
      const goals = Array.from(sdgGoalIds)
        .map(id => this.allSdgGoals.find(goal => goal.id === id || goal._id === id))
        .filter(goal => goal) // Remove any undefined entries
        .sort((a, b) => (a.goalNumber || 0) - (b.goalNumber || 0));

      return goals;
    }
  }
};
</script>

<style scoped>
.sdg-section-header {
  border-radius: 4px;
  padding: 16px 20px;
  margin-bottom: 16px;
}

.sdg-section-title {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 12px;
}

.sdg-goals-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.sdg-goal-icon {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
}

.sdg-goal-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .sdg-goal-icon {
    width: 50px;
    height: 50px;
  }
  
  .sdg-goals-container {
    gap: 8px;
  }
}
</style>